import { AxiosInstance } from 'axios';

export interface PhatoExameDownload {
  id?: string | number;
  numero?: string;
  nomePaciente?: string;
  dataPrometido?: string;
  dataLiberacao?: string;
  filename?: string;
  pdf?: string;
}

export function base64ToUint8Array(base64: string): Uint8Array {
  const normalized = base64.replace(/\s/g, '');
  const binary = atob(normalized);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export async function fetchPhatoExamePdf(
  api: AxiosInstance,
  idExame: string,
  token: string | null,
): Promise<{ bytes: Uint8Array; filename: string }> {
  if (!token) {
    throw new Error('Token Phato não encontrado. Faça login novamente.');
  }

  const { data } = await api.get<PhatoExameDownload>(
    `/v2/exame/${idExame}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );

  if (!data?.pdf) throw new Error('PDF não retornado pelo Pathoweb');

  return {
    bytes: base64ToUint8Array(data.pdf),
    filename: data.filename || `laudo_${idExame}.pdf`,
  };
}
